<template>
  <el-form-item v-bind="itemBinds" class="master-table" label-width="0">
    <!-- header -->
    <div class="master-table-header">
      <FormHeader>{{ $t('performanceAppraisal.performanceAppraisal.formTitle.useRule') }}</FormHeader>
    </div>
    <div class="evaluation-dimension-label">
      <span>{{ $t('performanceAppraisal.performanceAppraisal.evaluationDimension') }}</span>
      <span style="margin-left: 20px;">{{ value['judgeTypeName'] || '' }}</span>
    </div>
    <div class="classify-cell">
      <div
        v-for="(item) in value['materialCategory']"
        :key="item.judgeNo"
        class="classify-cell-btn"
      >
        {{ item.judgeName }}
      </div>
    </div>
    <div style="margin-top: 8px;">
      <vxe-table
        ref="dataTable"
        :data="value['examList']"
        border
        :resizable="true"
        show-overflow
        show-header-overflow
        show-footer-overflow
        style="width: 100%"
        :max-height="tableHeight"
      >
        <vxe-column fixed="left" type="seq" title="#" width="60" align="center" />
        <vxe-column
          v-for="quota of columns"
          :key="quota.prop"
          :title="quota.label"
          :field="quota.prop"
          align="center"
        />
        <vxe-column v-if="!disabled" fixed="right" :title="$t('performanceAppraisal.performanceAppraisal.supplierTable.action')" width="80" align="center">
          <template slot-scope="{ row, index }">
            <div class="delete-label" @click="deleteSupplier(row, index)">{{ $t('common.remove') }}</div>
          </template>
        </vxe-column>
        <template #empty>
          <Empty />
        </template>
      </vxe-table>
    </div>
  </el-form-item>
</template>

<script>
import FormHeader from '@/components/form/form-header/form-header.vue'
import Empty from '../small/empty.vue'
export default {
  name: 'UseRule',
  components: {
    FormHeader,
    Empty
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    itemBinds: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      columns: [
        { prop: 'supplierNo', label: this.$t('performanceAppraisal.performanceAppraisal.supplierTable.supplierNo') },
        { prop: 'supplierName', label: this.$t('performanceAppraisal.performanceAppraisal.supplierTable.supplierName') },
        { prop: 'classifyName', label: this.$t('performanceAppraisal.performanceAppraisal.supplierTable.classifyName') },
        { prop: 'supplierGroup', label: this.$t('performanceAppraisal.performanceAppraisal.supplierTable.supplierGroup') },
        { prop: 'statusName', label: this.$t('performanceAppraisal.performanceAppraisal.supplierTable.supplierStatus') },
        { prop: 'city', label: this.$t('performanceAppraisal.performanceAppraisal.supplierTable.city') }
      ],
      tableHeight: '500px'
    }
  },
  methods: {
    deleteSupplier(row) {
      const value = JSON.parse(JSON.stringify(this.value))
      if (value.examList.length === 1) {
        this.$message.warning(this.$t('performanceAppraisal.performanceAppraisal.tips1') || '')
        return
      }
      for (let i = 0; i < value.examList.length; i++) {
        if (value.examList[i].id === row.id) {
          value.examList.splice(i, 1)
          break
        }
      }
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.evaluation-dimension-label {
  width: 150px;
  height: 17px;
  font-family: PingFangHK-Regular,serif;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  margin-right: 23px;
  margin-bottom: 21px;
  &:before {
     content: "*";
     color: #de0010;
     margin-right: 4px
   }
}
.classify-cell {
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  .classify-cell-btn {
    box-sizing: border-box;
    height: 100%;
    border-radius: 16px;
    position: relative;
    transition: all .3s;

    background: #F6F6F6;
    color: #333333;
    padding-left: 20px;
    padding-right: 20px;
    margin-right: 15px;
    margin-bottom: 10px;
  }
}

.delete-label {
  cursor: pointer;
  color: #3778FB;
}

</style>
